import { queryGetReport } from '../Queries';
import moment from 'moment-timezone';

const convertToAPIBody = (facilityId, filterValues, format) => {
  const data = {};
  data.format = format;
  data.params = {};
  data.params.facilityId = facilityId;

  const {
    reportType,
    rateTypes,
    payorId,
    payorBillingName,
    dateOrder,
    transactionStartDate,
    transactionEndDate,
    applicationStartDate,
    applicationEndDate
  } = filterValues;

  switch (reportType) {
    case "RECONCILIATION":
      data.report = "ReconciliationReport";
      if (transactionStartDate) {
        data.params.transactionStartDate = moment(new Date(transactionStartDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD");
      }
      if (transactionEndDate) {
        data.params.transactionEndDate = moment(new Date(transactionEndDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD");
      }
      break;

    case "DETAIL":
      data.report = "PaymentDetailReport";
      data.params.transactionStartDate = transactionStartDate ? moment(new Date(transactionStartDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.transactionEndDate = transactionEndDate ? moment(new Date(transactionEndDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.applicationStartDate = applicationStartDate ? moment(new Date(applicationStartDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.applicationEndDate = applicationEndDate ? moment(new Date(applicationEndDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.subscriberId = payorId;
      data.params.subscriptionName = payorBillingName;

      switch (dateOrder) {
        case 'TRANSACTION_DATE':
          data.params.dateOrder = 'transaction';
          break;
        case 'APPLICATION_DATE':
        default:
          data.params.dateOrder = 'application';
          break;
      }
      break;

    case "SUMMARY":
      data.report = "PaymentSummaryReport";
      data.params.transactionStartDate = transactionStartDate ? moment(new Date(transactionStartDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.transactionEndDate = transactionEndDate ? moment(new Date(transactionEndDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.applicationStartDate = applicationStartDate ? moment(new Date(applicationStartDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.applicationEndDate = applicationEndDate ? moment(new Date(applicationEndDate.toLocaleDateString('en-US', { timeZone: 'UTC' }))).format("YYYY-MM-DD") : null;
      data.params.subscriberId = payorId;
      data.params.subscriptionName = payorBillingName;
      data.params.rateType = rateTypes.map(rate => rate.value);

      switch (dateOrder) {
        case 'TRANSACTION_DATE':
          data.params.dateOrder = 'transaction';
          break;
        case 'APPLICATION_DATE':
        default:
          data.params.dateOrder = 'application';
          break;
      }
      break;
    default:
      return null;
  }

  // Remove null key values
  Object.keys(data.params).forEach(key => {
    if (!data.params[key]) delete data.params[key];
  });

  return data;
}

export default {
  initialFilters: {
    reportType: '',
    rateTypes: [
      { label: "Monthly", value: "MONTHLY" },
      { label: "Validation & Other Types", value: "VALIDATION_OTHER" },
      { label: "Prepaid Validation", value: "PREPAID_VALIDATION" },
      { label: "Bill Back Validation", value: "BILL_BACK_VALIDATION" },
      { label: "Hotel Storage", value: "HOTEL_STORAGE" },
      { label: "Office/Retail Rent", value: "OFFICE_RETAIL_RENT" },
      { label: "Miscellaneous", value: "MISCELLANEOUS" }
    ],
    payorId: '',
    payorBillingName: '',
    dateOrder: '',
    transactionStartDate: null,
    transactionEndDate: null,
    applicationStartDate: null,
    applicationEndDate: null,
  },
  reportQuery: (facilityId, filterValues, format = "csv") => {
    const data = convertToAPIBody(facilityId, filterValues, format);
    return queryGetReport(data);
  },
  fileName: 'payment_report.csv',

}
